import PropTypes from 'prop-types'

import BookingOverview from './BookingOverview'

const BookingDetailsSidebar = ({ bookingData, timezone }) => {
  return (
    <div className="client-reservations-sidebar">
      <BookingOverview bookingData={bookingData} timezone={timezone} />
    </div>
  )
}

BookingDetailsSidebar.propTypes = {
  bookingData: PropTypes.object,
  timezone: PropTypes.string,
}

export default BookingDetailsSidebar
